
import { Button } from 'antd';


// export function PreviewDocument({ref}){
//     return(
//         <div>
//             <ReactToPdf targetRef={ref} filename="dcoument.pdf">
//                 {({toPdf}) => (
//                     <Button onClick={toPdf}>Preview Document</Button>
//                 )}
//             </ReactToPdf>
//             <div style={{width: 500, height: 500, background: 'blue'}} ref={ref}/>
//         </div>
//     )
// }

export function blobToPdf(blob, filename){
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename.includes(".") ? `${filename}` : `${filename}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function openPdf(blob){
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
}

